export const formData = (data: any) => {
	const bodyFormData = new FormData();

	for (const key in data) {
		if (Object.prototype.hasOwnProperty.call(data, key)) {
			if (data[key] !== undefined && data[key] !== null) {
				if (Array.isArray(data[key])) {
					if (data[key].length === 0) {
						bodyFormData.append(key, '[]');
					}

					data[key].forEach((val: any, index: number) => {
						if (typeof val === 'object' && val !== null) {
							for (const innerKey in val) {
								if (val[innerKey] !== undefined && val[innerKey] !== null) {
									bodyFormData.append(key + `[${index}]` + `[${innerKey}]`, val[innerKey]);
								}
							}
						} else {
							bodyFormData.append(key + `[${index}]`, val);
						}
					});
				} else {
					bodyFormData.append(key, data[key]);
				}
			}
		}
	}

	return bodyFormData;
};

export const filterJSONData = (data: any, nullAcceptableKeys: any) => {
	const filteredData: any = {};

	for (const key in data) {
		if (Object.prototype.hasOwnProperty.call(data, key)) {
			if (!!data[key] && typeof data[key] === 'object') {
				data[key] = filterJSONData(data[key], nullAcceptableKeys);
			}

			if ((data[key] !== undefined && data[key] !== null) || nullAcceptableKeys.includes(key)) {
				filteredData[key] = data[key];
			}
		}
	}

	if (Array.isArray(data)) return Object.values(filteredData);
	return filteredData;
};
